<template>
    <Row>
        <packageTable
          ref="contentBaseRef"
          class="contentBaseRef"
          :columnsData="columnsheader"
          :tableData="tableDataList"
          :reduceheight="reduceheight"
          :loading="tableLoading"
          :border="true"
          :tabletotallen="getPageTotal"
          :showSearchBtn="false"
          :tablePageSize="reqBase.page_size"
          @pageonChange="pageonChange"
          @pageSizeChange="pageSizeChange"
          @refreshBtn="init"
          @getSelect="getSelectList">
            <template slot="headLeft">
              <Form ref="formInline" :model="form_filter" class="tableHeaderForm" @keydown.enter.native="search" inline>
                <FormItem label="">
                    <Input type="text" style="width:120px" v-model="form_filter.project_name" placeholder="项目名称筛选"/>
                </FormItem>
                <FormItem label="">
                    <Input type="text" style="width:120px" v-model="form_filter.building_name" placeholder="建筑物名称筛选"/>
                </FormItem>
                <FormItem class="reduceFromMarginLeft">
                    <Button v-for="(item,index) in topButtonList" :type="item.type"
                            style="margin-right: 5px;" @click="item.method" :key="index">{{item.name}}</Button>
                </FormItem>
              </Form>
            </template>
            <template slot="headRight">
                <Tooltip v-for="(item,index) in topButtonList1" :key="index"  :content="item.name" placement="bottom">
                  <Button  
                      :type="item.type"      
                      style="margin-right: 5px;" 
                      @click="item.method" 
                      :key="index" 
                      :icon="item.icon"></Button>
              </Tooltip>
            </template>
        </packageTable>
        <Modal v-model="visible" :footer-hide="true" width="1000">
          <img :src="imgName" v-if="visible" style="width: 100%">
        </Modal>
    </Row>
</template>
<script>
import packageTableMixins from '@/mixins/packageTableMixins'
import addAppCustom from './components/addAppCustom'
import customDetails from './components/customDetails.vue'
import config from '@/config/index'
import {floor_add,floor_list,floor_del,floor_update} from '@/api/pests'
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data() {
    return {
      imgName:null,
      visible:false,
      setData:null,
      currClientId:null,//当前选择的应用id
      form_filter:{
        project_name:null,
        building_name:null
      },
      //共用的查询与重置
      topButtonList:[
        {
          name:'查询',
          type:'primary',
          method:this.search
        },
        {
          name:'重置',
          type:'error',
          method:this.reset
        }
      ],
      //共用的右侧添加按钮
      topButtonList1:[
        {
          name:'添加',
          icon:'ios-add',
          type:'primary',
          method:this.add
        },
        {
          name:'刷新',
          icon:'ios-refresh',
          type:'primary',
          method:this.init
        }
      ],
      reqBase: {
        page:1,
        page_size:15
      },
      status: true,//是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList:[
        {
          name:'编辑',
          type:'text',
          icon:'',
          method:this.edit
        },
        {
          name:'删除',
          type:'text',
          icon:'',
          method:this.del
        },
      ],
      operationButtonList1:[
        {
          name:this.$t('operationModule.submitReview'),
          type:'text',
          icon:'',
          method:this.submitReview
        },
      ],
      columnsheader: [
        // {
        //   align: 'center',
        //   title: '序号',
        //   minWidth:120,
        //   key: 'xuhao',
        // },
         {
          align: 'center',
          title: '楼层',
          minWidth:120,
          key: 'floor_num',
        },
        {
          align: 'center',
          title: '建筑物名称',
          minWidth:120,
          key: 'building_name',
        },
        {
          align: 'center',
          title: '所属项目',
          minWidth:120,
          key: 'project_name'
        },
        {
          align: 'center',
          title: '平面图',
          minWidth:100,
          key: 'file_url',
          render:(h,{row})=>{
            return h('div',{
              style:{
                width:'100px',
                height:'100px',
                margin:'0 auto',
                textAlign:'center'
              }
            },[
              h('img',{
              style:{
                width:'100%',
                height:'100px'
              },
              domProps:{
                src:row.file_url
              },
              on:{
                click:()=>{
                  this.visible=true;
                  this.imgName=row.file_url
                }
              }
            })
            ])
          }
        },
        {
          align: 'center',
          title: '创建日期',
          minWidth:100,
          key: 'addtime'
        },
        {
          align: 'center',
          title: '操作',
          minWidth:150,
          key: 'Operating',
          render: (h, {row}) => {
            let arr=[];
            for(let i in this.operationButtonList){
                let list=this.operationButtonList[i];
                arr.push(h('Button',{
                  style:{marginLeft:'5px',marginBottom:'3px',color:'#2d8cf0',},
                  props:{
                    type:list.type,
                    size:list.size?list.size:'small'
                  },
                  on:{
                    click:()=>{
                      list.method(row)
                    }
                  }
                },list.name));
              }

            return h('div',arr)
          }
        },
      ],
    }
  },
  components: {
    customDetails
  },
  computed: {

  },
  props:{
    reducehe:{},
    code:{}
  },
  methods: {
    mechanHome(row){
      window.open(config.webLinkUrl+'/index/'+row.company_code)
    },
    pageSizeChange(){

    },
    init() {
      this.tableLoading = true;
      floor_list({...this.reqBase}).then(res => {
        this.tableLoading = false;
        this.tableDataList = [];
        if (res.result === 0) {
          this.tableDataList = res.body.list || [];
          this.getPageTotal = res.body.total;
        }else{
          this.tableDataList = [];
          this.getPageTotal = 0;
          this.$Message.error(res.errorMsg);
        }
      });
    },
    //新增
    add() {
      let vm = this;
      let config = {
        loading: true,
        width: 800,
        render: (h) => {
          return h('div', [
            h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '5px' } }, '添加'),
              h('icon', {
                props: { type: 'md-close', size: '16' },
                style: {
                  cursor: 'pointer'
                },
                on: {
                  'click': evt => {
                    vm.$Modal.remove()
                  }
                }
              })
            ]),
            h('Divider',{
              style:{
                margin:'8px 0'
              }
            }),
            h(addAppCustom, {
              ref: 'addAppCustom',
              props: {
                _vm: vm,
                $store:vm.$store,
                edit:false,
              }
            })
          ])
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.addAppCustom;
          
          obj.checkForm().then(res => {
            if (res) {
              //提交请求
              let formModel = obj.formModel;
              
              floor_add(formModel).then(res => {
                let msg=res.errorMsg;
                if (res.result === 0) {
                  let msg=res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    search(){
      this.onSearch(this.form_filter);
    },
    reset() {
      this.form_filter={
        project_name:null,
        building_name:null
      };
      this.search();
    },
    details(row){
      let vm = this;
      let config = {
        loading: true,
        width: 800,
        okText:'关闭',
        render: (h) => {
          return h('div', [
            h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '15px' } }, '详情'),
              h('icon', {
                props: { type: 'md-close', size: '16' },
                style: {
                  cursor: 'pointer'
                },
                on: {
                  'click': evt => {
                    vm.$Modal.remove()
                  }
                }
              })
            ]),
            h(customDetails, {
              ref: 'customDetails',
              props: {
                _vm: vm,
                $store:vm.$store,
                edit:true,
                setData: row
              }
            })
          ])
        },
        onOk: function () {
          vm.$Modal.remove();
        }
      };
      this.$Modal.success(config);
    },
    edit(row) {
      let vm = this;
      let config = {
        loading: true,
        width: 800,
        render: (h) => {
          return h('div', [
            h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '15px' } }, '编辑'),
              h('icon', {
                props: { type: 'md-close', size: '16' },
                style: {
                  cursor: 'pointer'
                },
                on: {
                  'click': evt => {
                    vm.$Modal.remove()
                  }
                }
              })
            ]),
            h(addAppCustom, {
              ref: 'addAppCustom',
              props: {
                _vm: vm,
                $store:vm.$store,
                edit:true,
                setData: row
              }
            })
          ])
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.addAppCustom;
          obj.checkForm().then(req => {
            if (req) {
              //提交请求
              let formModel= obj.formModel;
              floor_update({...formModel,company_code:row.company_code}).then(res => {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    del(row) {
      let vm = this;
      let config = {
        loading: true,
        title: '删除',
        content:'您确定要删除 '+row.project_name+''+row.floor_num+'楼吗？',
        onOk: function () {
          let _this = this;
          floor_del({id:row.id}).then(res => {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    }
  },
  mounted() {
    if(this.code){
      this.$set(this.reqBase,'project_code',this.code)
    }
    if(this.reducehe){
      this.reduceheight=this.reducehe
    }else{
       this.init();
    }
  },
  created() {
    // this.getPageSizeToStorage();
  }
}
</script>
<style scoped>
  .div2 {
    font-size: 15px;
    text-align: center;
  }
  .contentBaseRef /deep/ .headerWrapper{
    align-items: center;
  }
</style>
